import { useCallback, useEffect, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import { EQM2080DetailTabType, useEQM2080_R01Store } from "./Store_EQM2080_R01";
import { EQM2080_R01DetailPivotDto } from "./Dto_EQM2080_R01";
import { NITable_EQM2080_R01 } from "./NITable_EQM2080_R01";
import { CNTable_EQM2080_R01 } from "./CNTable_EQM2080_R01";
import { EQM2080_R01_DETAIL_TABS, EQM2080_R01_EQUIPMENT_CD } from "./utils/tabConfig";

interface Props {
	niGridRef: React.RefObject<AgGridReact<EQM2080_R01DetailPivotDto> | null>;
	cnGridRef: React.RefObject<AgGridReact<EQM2080_R01DetailPivotDto> | null>;
}

export const TableTab_EQM2080_R01 = (props: Props) => {
	const { niGridRef, cnGridRef } = props;
	const {
		activeDetailTab,
		setActiveDetailTab,
		setEQM2080_R01Filter,
		initSelectedEQM2080_R01,
	} = useEQM2080_R01Store();
	const [gridKey, setGridKey] = useState(0);

	useEffect(() => {
		setGridKey((prev) => prev + 1);
	}, [activeDetailTab]);

	const handleTabClick = useCallback((tab: EQM2080DetailTabType) => {
		if (tab === activeDetailTab) return;
		initSelectedEQM2080_R01();
		setActiveDetailTab(tab);
		setEQM2080_R01Filter({ equipmentCd: tab, equipmentNm: "" });
	}, [activeDetailTab, initSelectedEQM2080_R01, setActiveDetailTab, setEQM2080_R01Filter]);

	return (
		<div className="w-full h-full flex flex-col">
			<div
				className="flex items-end mb-[0.1px] bg-white h-[25px]"
				role="tablist"
				aria-label="도금라인 점검 탭"
			>
				{EQM2080_R01_DETAIL_TABS.map((tab) => {
					const isActive = activeDetailTab === tab.id;
					return (
						<button
							key={tab.id}
							type="button"
							onClick={() => handleTabClick(tab.id)}
							role="tab"
							aria-selected={isActive}
							className={`h-[26px] px-3 text-[12px] font-medium transition-colors border border-gray-300 border-b-0
								${isActive
									? "bg-white text-black-700 -mb-px shadow-sm"
									: "bg-gray-100 text-gray-700 hover:bg-gray-200"}
							`}
						>
							{tab.label}
						</button>
					);
				})}
			</div>

			<div className="flex-1 min-h-0">
				{activeDetailTab === EQM2080_R01_EQUIPMENT_CD.NICKEL_CHROME ? (
					<NITable_EQM2080_R01 key={gridKey} gridRef={niGridRef} />
				) : (
					<CNTable_EQM2080_R01 key={gridKey} gridRef={cnGridRef} />
				)}
			</div>
		</div>
	);
};
